import React, { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import axios from 'axios';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { IconButton, Icon, Grid, Typography, RadioGroup, FormControl, FormLabel, FormControlLabel, Radio, Button, Tooltip, Box, CircularProgress } from '@material-ui/core';
import { green, red } from '@material-ui/core/colors';
import { toastr } from 'react-redux-toastr';
import { URL } from '../../assets/js/constants';

import { getFuncionariosDoNegocio } from '../../store/actions/funcionario';
import { getListaPerfilDeNegocio, atualizarPerfilNegocioUsuario } from '../../store/actions/usuario';
import TituloPagina from '../../components/layout/TituloPagina';
import DataTableComponent from '../../components/form/DataTableComponent';
import DialogAlert from '../../components/layout/DialogAlert';

const Funcionario = props => {
    const history = useHistory();
    const {
        user,
        funcionarios,
        getFuncionariosDoNegocio,
        getListaPerfilDeNegocio,
        negocioDoUsuario,
        listaPerfil,
        atualizarPerfilNegocioUsuario,
        loading
    } = props
    const { perfis } = user;
    const [toggleAtualizarPerfilDialog, setToggleAtualizarPerfilDialog] = useState(false);
    const [selectedPerfil, setSelectedPerfil] = useState('');
    const [usuarioNovoPerfil, setUsuarioNovoPerfil] = useState('');

    useEffect(_ => {
        getFuncionariosDoNegocio(negocioDoUsuario);
        getListaPerfilDeNegocio();
    }, [negocioDoUsuario]);

    const columns = [
        {
            name: 'ID',
            selector: (row) => row.id,
            width: '70px',
            sortable: true,
        },
        {
            name: 'Matrícula',
            selector: (row) => row.matricula,
            sortable: true,
            width: '120px',
        },
        {
            name: 'Nome',
            selector: (row) => row.nomeCompleto,
            sortable: true,
        },
        {
            name: 'CPF',
            selector: (row) => row.cpf,
            sortable: true,
            width: '150px',
        },
        {
            name: 'Negócio',
            selector: (row) => row.nomeNegocio,
            sortable: true,
            width: '250px',
        },
        {
            name: 'Status',
            center: 'true',
            selector: (row) => (
                row.ativo ? <Icon fontSize='small' style={{ color: green[500] }}>check_circle</Icon> : <Icon fontSize='small' style={{ color: red[500] }}>cancel</Icon>
            ),
            width: '100px',
            sortable: true,
        },
        {
            name: 'Ações',
            center: 'true',
            cell: (row) => (
                <>
                    <Tooltip title='Editar Funcionário' placement='right'>
                        <IconButton style={{ padding: 1 }} aria-label="editar" size='small' color='secondary' onClick={() => handleEditarFuncionario(row.id)} ><Icon>edit</Icon></IconButton>
                    </Tooltip>
                    {perfis.includes('GERENTE_NEGOCIO') && (
                        <Tooltip title='Perfil de Acesso' placement='right'>
                            <IconButton style={{ padding: 1 }} aria-label="perfil" size='small' color='secondary' onClick={() => toggleDialogPerfil(row.idUsuario)} > <Icon>security</Icon></IconButton>
                        </Tooltip>
                    )}
                </>
            ),
            width: '100px'
        }
    ];

    const handleEditarFuncionario = (id) => {
        history.push({
            pathname: '/funcionarios-da-loja/editar-funcionario',
            state: {
                funcionarioId: id,
                from: window.location.pathname,
            },
        });
    }

    async function toggleDialogPerfil(idUsuario) {
        try {
            const perfil = await perfilDeNegocioDoUsuario(idUsuario);
            setSelectedPerfil(perfil[0] || []);
            setUsuarioNovoPerfil(idUsuario);
            setToggleAtualizarPerfilDialog(true);
        } catch (error) {
            console.error("Erro ao buscar perfil:", error);
        }
    }

    function handleConfirmarPerfil() {
        const data = { id: usuarioNovoPerfil, perfis: [selectedPerfil] }
        atualizarPerfilNegocioUsuario(data);
        setToggleAtualizarPerfilDialog(false);
    }

    function handleChangePerfilNegocio(event) {
        setSelectedPerfil(event.target.value);
    }

    async function perfilDeNegocioDoUsuario(idUsuario) {
        try {
            const response = await axios.get(`${URL}/usuarios/perfil-de-negocio/perfil-do-usuario/${idUsuario}`);
            return response.data;
        } catch (e) {
            toastr.error('Erro', 'Não foi possível atualizar lista de funcionários. Erro: ' + e.message);
            throw e;
        }
    }

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4, height: '70vh' }}>
                <CircularProgress size={48} />
            </Box>
        );
    }

    return (
        <>
            <TituloPagina titulo='Meus Funcionários' subtitulo={new Date().toLocaleString('pt-BR')} />
            <Box sx={{ height: '70vh' }}>
                <DataTableComponent
                    columns={columns}
                    data={funcionarios}
                    visibleSearch={funcionarios && funcionarios.length > 0}
                    camposParaBusca={['matricula', 'nomeCompleto', 'cpf', 'nomeNegocio']}
                />
                <Grid container >
                    <Button component={Link} variant='contained' color='secondary' to={{ pathname: '/funcionarios-da-loja/cadastrar-funcionario', state: { from: window.location.pathname } }}>Cadastrar Funcionário</Button>
                </Grid>
            </Box>
            <DialogAlert
                title='Definir Perfil do Funcionário'
                fullWidth={true}
                maxWidth='sm'
                okButton={true}
                okButtonType='submit'
                okButtonClick={() => handleConfirmarPerfil()}
                labelOkButton='Confirmar'
                cancelButton={true}
                cancelButtonClick={() => setToggleAtualizarPerfilDialog(false)}
                labelCancelButton='Cancelar'
                openDialog={toggleAtualizarPerfilDialog}
            >
                <Grid container item>
                    <Grid item xs >
                        <Typography variant="subtitle1" style={{ color: '#999997', paddingBottom: '15px' }}>Selecione o novo perfil do funcionário.</Typography>
                        <Grid item sx>
                            <FormControl component="fieldset">
                                <FormLabel component="legend">Perfil</FormLabel>
                                <RadioGroup aria-label="perfil" name="perfil" value={selectedPerfil} onChange={handleChangePerfilNegocio}>
                                    {
                                        listaPerfil.map(p => <FormControlLabel key={p} value={p} control={<Radio />} label={p} />)
                                    }
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                    </Grid>
                </Grid>
            </DialogAlert>
        </>
    )
}

const mapStateToProps = state => ({
    user: state.auth.user,
    listaPerfil: state.usuario.listaPerfil,
    negocioDoUsuario: state.negocio.negocioDoUsuario,
    funcionarios: state.funcionario.funcionarios,
    loading: state.funcionario.loading
})
const mapDispatchToProps = dispatch => bindActionCreators({
    getFuncionariosDoNegocio,
    getListaPerfilDeNegocio,
    atualizarPerfilNegocioUsuario,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(Funcionario)